// @core/api/endpoints/team/reset_team_security_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ResetTeamSecuritySettingsRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Reset team security settings
 * Performs reset operation on team security settings.
 */
export async function ResetTeamSecuritySettings(
  team_id: string,
  data: ResetTeamSecuritySettingsRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/settings/security/reset`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
